import { retriever } from '@retriever-ui/system'
import React, { useEffect } from 'react'

import { ArrowIcon } from '../../../assets/icons/arrow.icon'
import * as S from './styled'

const Button = (props) => {
  return (
    <retriever.div
      bg="black.0"
      h={32}
      maxH={32}
      w={32}
      maxW={32}
      radius={16}
      d="flex"
      alignItems="center"
      justifyContent="center"
      shadow="2px 2px 8px 1px black.300/6"
      pos="relative"
      {...props}
    >
      {props.children}
    </retriever.div>
  )
}

const ListControls = ({
  listRef,
  leftScrolled,
  scrollValidation,
  buttonColors = { icon: 'black', background: 'black.0' },
  cardWidth,
}) => {
  const scrollToRight = () => {
    listRef?.current?.scrollBy({
      left: cardWidth + 1,
      behavior: 'smooth',
    })
  }

  const scrollToLeft = () => {
    listRef?.current?.scrollBy({
      left: -cardWidth - 1,
      behavior: 'smooth',
    })
  }

  useEffect(() => {
    if (listRef) {
      listRef?.current?.scrollTo(0, 0)
    }
  }, [listRef])

  return (
    <>
      {leftScrolled > 20 && (
        <S.PreviousButton onClick={scrollToLeft}>
          <Button bg={buttonColors.background} left={[-16, -20]}>
            <ArrowIcon
              color={buttonColors.icon}
              direction="left"
              height={12}
              style={{ position: 'relative', marginRight: 2 }}
            />
          </Button>
        </S.PreviousButton>
      )}
      {!scrollValidation && (
        <S.NextButton onClick={scrollToRight}>
          <Button
            bg={buttonColors.background}
            left="initial"
            right={[-16, -20]}
          >
            <ArrowIcon
              height={12}
              color={buttonColors.icon}
              style={{ marginLeft: 2 }}
            />
          </Button>
        </S.NextButton>
      )}
    </>
  )
}

export default ListControls
